import { localizedNumber } from "shared/numberParser";
import { defaultArrowAnnotationLeft, defaultArrowAnnotationTop, defaultGridColor, defaultHoverLabel, defaultPlotConfig, defaultSpikeConfig, defaultTickFont, } from "shared/plotly/defaultConfigs";
import * as colors from "styles/colorValues.module.scss";
const { decimal, group } = localizedNumber.numberSeparators;
export const plotConfig = {
    ...defaultPlotConfig,
    showAxisDragHandles: false,
    showAxisRangeEntryBoxes: false,
    scrollZoom: false,
};
const defaultAxisConfig = {
    tickfont: defaultTickFont,
    zeroline: false,
    linewidth: 1,
    tickwidth: 1,
    gridcolor: defaultGridColor,
    linecolor: colors.s900,
};
export const plotLayout = {
    autosize: true,
    dragmode: false,
    hovermode: "closest",
    showlegend: false,
    hoverlabel: defaultHoverLabel,
    paper_bgcolor: "transparent",
    plot_bgcolor: "transparent",
    margin: {
        l: 10,
        r: 10,
        b: 25,
        t: 8,
    },
    separators: `${decimal}${group}`,
    annotations: [defaultArrowAnnotationTop, defaultArrowAnnotationLeft],
    xaxis: {
        ...defaultAxisConfig,
        ...defaultSpikeConfig,
    },
    yaxis: { ...defaultAxisConfig, zeroline: false, showticklabels: false },
};
export const prepareGraphData = (points) => [
    {
        x: points.map(({ x }) => (isNaN(x) ? null : x)),
        y: points.map(({ y }) => (isNaN(y) ? null : y)),
        line: { color: colors.s800 },
        mode: "lines+markers",
        type: "scatter",
        marker: { opacity: 0, size: 4 },
        hovertemplate: `<br>%{x}, %{y}<extra></extra>`,
    },
];
